<template>
  <v-sheet height="100%" width="100%" color="bg1" class="fm-page">
    <header class="fm-page__header">
      <h1 class="fm-page__title">Feedback</h1>
      <p class="fm-page__subtitle">What users think of AVA, and how often they are asked.</p>
    </header>

    <v-tabs v-model="tab" class="fm-page__tabs" background-color="transparent">
      <v-tab>Submissions</v-tab>
      <v-tab>Settings</v-tab>
    </v-tabs>

    <v-divider />

    <!--
      The page owns the viewport height and never scrolls itself; the table
      scrolls inside its own card instead, so the filters, the header row and the
      pager all stay put while paging through submissions.
    -->
    <v-tabs-items v-model="tab" class="fm-page__panels">
      <v-tab-item :transition="false" class="fm-page__panel">
        <feedback-results-table />
      </v-tab-item>
      <v-tab-item :transition="false" class="fm-page__panel fm-page__panel--scroll">
        <feedback-settings-panel />
      </v-tab-item>
    </v-tabs-items>
  </v-sheet>
</template>

<script>
  import FeedbackResultsTable from '@Feedback/components/FeedbackResultsTable.vue';
  import FeedbackSettingsPanel from '@Feedback/components/FeedbackSettingsPanel.vue';

  export default {
    name: 'FeedbackManagement',

    components: { FeedbackResultsTable, FeedbackSettingsPanel },

    data() {
      return {
        // Submissions first: reading feedback is the daily job; changing the
        // cadence is a rare administrative one.
        tab: 0,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .fm-page {
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 20px 24px 24px;
    overflow: hidden;
  }

  .fm-page__header {
    flex: 0 0 auto;
    margin-bottom: 10px;
  }

  .fm-page__title {
    font-family: var(--ds-font-family-heading, 'Poppins'), sans-serif;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .fm-page__subtitle {
    font-size: 13px;
    color: var(--v-text-base);
    margin: 4px 0 0;
  }

  .fm-page__tabs {
    flex: 0 0 auto;
  }

  .fm-page__tabs ::v-deep .v-tab {
    letter-spacing: 0;
    text-transform: none;
    font-size: 14px;
  }

  // v-tabs-items and its inner window container are plain divs that shrink-wrap
  // by default, so the height has to be handed down explicitly at every level or
  // the table below never gets a definite height to scroll within.
  .fm-page__panels {
    flex: 1 1 auto;
    min-height: 0;
    padding-top: 16px;
    background: transparent;

    ::v-deep .v-window__container {
      height: 100%;
      background: transparent;
    }
  }

  .fm-page__panel {
    height: 100%;
  }

  // The settings tab is a short form, not a table: let it scroll normally.
  .fm-page__panel--scroll {
    overflow-y: auto;
  }
</style>
